import { render, staticRenderFns } from "./CollapsePanel.vue?vue&type=template&id=2db41bd0&scoped=true&"
import script from "./CollapsePanel.vue?vue&type=script&lang=js&"
export * from "./CollapsePanel.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePanel.vue?vue&type=style&index=0&id=2db41bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db41bd0",
  null
  
)

export default component.exports